import React from "react";

import { Headline, Label, Paragraph } from "@fronterahealth/frontera-ui-components";

import { ProgrammingReviewGoalForm } from "@pages/ClientProgramming/ProgrammingReview/components/ProgrammingReviewGoalForm";
import { ProgrammingReviewTargetForm } from "@pages/ClientProgramming/ProgrammingReview/components/ProgrammingReviewTargetForm";
import { useProgrammingReviewData } from "@providers/ProgrammingReviewProvider";

interface ProgrammingReviewRightPanelProps {
  isReadOnly?: boolean;
}

const EmptyState: React.FC = () => (
  <div className="flex-1 flex flex-col items-center justify-center gap-3">
    <Headline size="extra-small">No Goal or Target Selected</Headline>
    <Paragraph colorType="secondary">Click on a goal or target from the list to see and edit its details.</Paragraph>
  </div>
);

export const ProgrammingReviewRightPanel: React.FC<ProgrammingReviewRightPanelProps> = ({ isReadOnly = false }) => {
  const { selectedProgramReviewGoal, selectedProgramReviewTarget } = useProgrammingReviewData();
  const hasSelection = selectedProgramReviewTarget || selectedProgramReviewGoal;
  const title = selectedProgramReviewTarget
    ? selectedProgramReviewTarget.title
    : selectedProgramReviewGoal
      ? selectedProgramReviewGoal.title
      : "";

  return (
    <div className="flex-1 flex flex-col border-l border-limestone-100 overflow-y-auto">
      {hasSelection && (
        <div className="flex sticky top-0 z-10 flex-row gap-4 p-3 min-h-[45px] bg-white w-full border-b border-limestone-200">
          <Label size="small" colorType="primary" displayType="loud">
            {title}
          </Label>
        </div>
      )}

      <div className="flex-1 flex flex-col items-center px-20 py-6 w-full">
        {selectedProgramReviewTarget ? (
          <ProgrammingReviewTargetForm isReadOnly={isReadOnly} />
        ) : selectedProgramReviewGoal ? (
          <ProgrammingReviewGoalForm isReadOnly={isReadOnly} />
        ) : (
          <EmptyState />
        )}
      </div>
    </div>
  );
};
